import { FieldRadioGroup, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { OrdinateurTchat } from '@workspace/core-ts/icons-amo';
import { AvReason, AvReasonArray } from '../AvReason';
import type { FormSchemaType } from '../schema';

export default function SelectionMotifAvenant() {
  const methods = useSmartFormGlobal<FormSchemaType>();

  const avReasonWithOnChange = AvReasonArray.map((reason) => ({
    ...reason,
    onChange: (value: any) => {
      switch (value) {
        case AvReason.AJOUT_DE_VEHICULES.value:
          methods.setValue('DemandeTarif.ListeVehicules', []);

          break;
        case AvReason.CHANGEMENT_DE_GARANTIES.value:
          break;
        default:
          break;
      }
    },
  }));

  return (
    <SmartFormGlobal
      {...methods}
      className="mx-auto"
    >
      <Question>
        <Question.Header>
          <OrdinateurTchat />
          <Question.Title>
            Quel est le <b>motif de votre avenant</b> ?
          </Question.Title>
        </Question.Header>

        <FieldRadioGroup
          name="DemandeTarif.Police.MotifAvenant"
          options={avReasonWithOnChange}
        />
      </Question>
    </SmartFormGlobal>
  );
}
